import React, { useRef, useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ICON_SAVE, ICON_CANCEL } from '../../extras/icons';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveInhibitionsAction, updateInhibitionsAction } from '../../../actions/inhibitionsActions';
import { listInhibitionTypesAction } from '../../../actions/inhibitionTypesActions';
import { listJudgesAction } from '../../../actions/judgesActions';
import { Formik } from 'formik';
import ButtonSpinner from '../../layout/ButtonSpinner';
import * as yup from 'yup';
import { setLocale } from 'yup';
//Función principal
const InhibitionForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refJuez = useRef();
    //Datos iniciales
    const initialData = {
        juez: '',
        inicio: '',
        fin: '',
        tipo: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const inhibitionsLoading = useSelector( state => state.inhibitions.loadingSave );
    const errorSave = useSelector( state => state.inhibitions.errorSave );
    const isEdit = useSelector( state => state.inhibitions.isEdit );
    const inhibitionSelected = useSelector( state => state.inhibitions.inhibitionSelected );
    const judges = useSelector( state => state.judges.judges );
    const inhibitionTypes = useSelector( state => state.inhibitionTypes.inhibitionTypes );
    //Inicializo el state local
    const [ inhibition, setInhibition ] = useState(initialData);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && inhibitionSelected){
            setInhibition({
                ...inhibitionSelected,
                juez: inhibitionSelected.juez.id,
                tipo: inhibitionSelected.tipo.id
            });
        }else{
            setInhibition(initialData);
        }
    }, [isEdit, inhibitionSelected, show])
    //Manejo de cambios
    const handleChange = e => {
        setInhibition({
            ...inhibition,
            [e.target.name]: e.target.value
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Armo el objeto de datos
        let data = {
            juez: {
                id: values.juez
            },
            inicio: values.inicio,
            fin: values.fin,
            tipo: {
                id: values.tipo
            },
            activo: 1
        }
        //Verifico si es edición o alta
        if(inhibition.id){
            //Agrego el id
            data = {
                id: inhibition.id,
                ...data
            }
            //Es edición
            dispatch( updateInhibitionsAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveInhibitionsAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Me fijo si cargó los jueces
        if(!judges){
            const params = {
                search: 'activo:1',
                sort: 'apellido:asc,nombre:asc'
            }
            dispatch( listJudgesAction(params) );
        }
        //Me fijo si cargó los tipos
        if(!inhibitionTypes){
            const paramsTypes = {
                search: 'activo:1',
                sort: 'descripcion:asc'
            }
            dispatch( listInhibitionTypesAction(paramsTypes) );
        }
        //Pongo el foco en el primer campo
        refJuez.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setInhibition(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        juez: yup.number().required(),
        inicio: yup.date().required(),
        fin: yup.date().required().min(yup.ref('inicio')),
        tipo: yup.number().required()
    });
    //Renderizo
    return (
        <Modal show={show} onHide={handleCloseForm} onShow={handleOnShow} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Inhibición&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...inhibition }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-12">
                                    <label htmlFor="juez">Juez/Magistrado</label>
                                    <Form.Control
                                        as="select"
                                        id="juez"
                                        className="form-control"  
                                        name="juez" 
                                        autoFocus 
                                        value={ values.juez }
                                        onChange={handleChange}
                                        isInvalid={!!errors.juez}
                                        disabled={ inhibitionsLoading }
                                        ref={refJuez}
                                    >
                                        <option value="">Seleccione un Juez/Magistrado</option>
                                        {
                                            judges ? (
                                                judges.map(judge => (
                                                    <option value={judge.id} key={`ij${judge.id}`}>
                                                        { `${judge.apellido}, ${judge.nombre}`  }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.juez }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="inicio">Fecha inicio</label>
                                    <Form.Control
                                        id="inicio"
                                        className="form-control" 
                                        name="inicio" 
                                        type="date" 
                                        value={ values.inicio }
                                        onChange={handleChange}
                                        isInvalid={!!errors.inicio}
                                        disabled={ inhibitionsLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.inicio }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="fin">Fecha fin</label>
                                    <Form.Control
                                        id="fin"
                                        className="form-control" 
                                        name="fin" 
                                        type="date" 
                                        value={ values.fin }
                                        onChange={handleChange}
                                        isInvalid={!!errors.fin}
                                        disabled={ inhibitionsLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fin }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="tipo">Tipo</label>
                                    <Form.Control
                                        as="select"
                                        id="tipo"
                                        className="form-control"  
                                        name="tipo" 
                                        autoFocus 
                                        value={ values.tipo }
                                        onChange={handleChange}
                                        isInvalid={!!errors.tipo}
                                        disabled={ inhibitionsLoading }
                                    >
                                        <option value="">Seleccione el Tipo</option>
                                        {
                                            inhibitionTypes ? (
                                                inhibitionTypes.map(inhibitionType => (
                                                    <option value={inhibitionType.id} key={`it${inhibitionType.id}`}>
                                                        { inhibitionType.descripcion  }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.tipo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                inhibitionsLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ inhibitionsLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ inhibitionsLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default InhibitionForm;